/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_LabelInputs */

const en_blog_label = /** @type {(inputs: Blog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Lindevo blog`)
};

const lv_blog_label = /** @type {(inputs: Blog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo raksti`)
};

/**
* | output |
* | --- |
* | "The Lindevo blog" |
*
* @param {Blog_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_label = /** @type {((inputs?: Blog_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_label(inputs)
	return en_blog_label(inputs)
});